/**
 * Schémas Zod CRM — opportunités commerciales et pipeline.
 */
import { z } from 'zod';
import { OPPORTUNITY_STATUSES } from '../enums/crm.enum.js';
import { paginationQuerySchema, searchSchema, uuidSchema } from './common.schema.js';
const optionalText = (max) => z.string().trim().max(max).nullable().optional();
/** Montant HT : nombre ou chaîne décimale, jusqu'à 4 décimales. */
const amountSchema = z
    .union([z.number(), z.string().regex(/^\d{1,11}(\.\d{1,4})?$/, { message: 'Montant invalide.' })])
    .nullable()
    .optional();
/** Montant purement positif, tel que fourni à l'écriture. */
const currencySchema = z.string().trim().length(3).toUpperCase().optional();
const probabilitySchema = z.number().int().min(0).max(100).nullable().optional();
const isoDateTimeSchema = z.string().datetime().nullable().optional();
const opportunityBaseSchema = {
    title: z.string().trim().min(1).max(180),
    stageId: uuidSchema.nullable().optional(),
    amount: amountSchema,
    currency: currencySchema,
    probability: probabilitySchema,
    expectedCloseAt: isoDateTimeSchema,
    source: optionalText(60),
    notes: optionalText(2000),
    prospectId: uuidSchema.nullable().optional(),
    clientId: uuidSchema.nullable().optional(),
    sellerUserId: uuidSchema.nullable().optional(),
    assigneeUserId: uuidSchema.nullable().optional(),
};
/** Paramètres de `GET /opportunities`. */
export const opportunityListQuerySchema = paginationQuerySchema.extend({
    search: searchSchema,
    filter: z
        .object({
        status: z.enum(OPPORTUNITY_STATUSES).optional(),
        stageId: uuidSchema.optional(),
        sellerUserId: uuidSchema.optional(),
        assigneeUserId: uuidSchema.optional(),
        clientId: uuidSchema.optional(),
        prospectId: uuidSchema.optional(),
    })
        .optional(),
});
/** Corps de `POST /opportunities`. */
export const opportunityCreateSchema = z
    .object(opportunityBaseSchema)
    .refine((value) => (value.prospectId ?? null) !== null || (value.clientId ?? null) !== null, {
    message: 'Une opportunité doit être rattachée à un prospect ou à un client.',
    path: ['clientId'],
});
/** Corps de `PATCH /opportunities/:id`. */
export const opportunityUpdateSchema = z
    .object(opportunityBaseSchema)
    .partial()
    .refine((value) => Object.values(value).some((field) => field !== undefined), {
    message: 'Aucun champ à mettre à jour.',
});
/** Corps de `PATCH /opportunities/:id/stage` — déplacement kanban. */
export const opportunityMoveSchema = z.object({
    stageId: uuidSchema,
    probability: probabilitySchema,
    lostReason: optionalText(255),
});
//# sourceMappingURL=opportunity.schema.js.map